import { stringify } from 'qs';
import request from '@/utils/request';
import { getUser } from '@/utils';

export async function save(params) {
  return request(`/api/blade-interact/supervisionRecord/save`, {
    method: 'POST',
    body: params,
  });
}

export async function detail(params) {
  return request(`/api/blade-interact/supervisionRecord/detail?${stringify(params)}`,
  );
}

export async function detailForUser(params) {
  const { deptId, userId } = getUser() || {};
  return request(`/api/blade-interact/supervisionRecord/detail?${stringify({ deptId, userId, ...params })}`,)
}

export async function allList(params) {
  return request(
    `/api/blade-interact/supervisionRecord/alllist?${stringify(params)}`,
  );
}
export async function ifsettingsuser(params) {
  return request(
    `/api/blade-interact/supervisionRecord/ifsettingsuser?${stringify(params)}`,
  );
}
